import * as React from 'react';
import Lightbox from 'react-image-lightbox';
// @ts-ignore
import ReactImageMagnify from 'react-image-magnify';
import CountryService from '../../../../services/CountryService';
import ProductTags from '../../../../modules/ProductTags';
import Image from '../../../../components/Image';
import { addWebpSuffixIfSupported } from '../../../../utils/webP';

interface IImageGalleryProps {
  images: Array<GQL.IImage> | null;
  variant: GQL.IProductVariant;
}

interface IImageGalleryState {
  displayImage: number;
  openLightBox: boolean;
  imagesLoaded?: number;
}

class ImageGallery extends React.Component<IImageGalleryProps, IImageGalleryState> {

  constructor(props: IImageGalleryProps) {
    super(props);

    this.state = {
      displayImage: 0,
      openLightBox: false
    };

    this.onClickImage = this.onClickImage.bind(this);
  }

  public render() {
    const { images, variant } = this.props;
    const { displayImage, openLightBox } = this.state;
    const { language } = CountryService.GetInstance();

    const lighBoxImages = images ?
      images.map((image: GQL.IImage) => {
        return Image.createUrlImage({ image });
      }) : [];

    // url hlavního obrázku
    let imageSrc = null;
    let largeImageSrc = null;
    if (images && images.length > 0) {
      const rawImageSrc = Image.createUrlImage({ image: images[0], width: 450, height: 450 }); // Do 18. 12. 2023 widdth a height nebyly definovány
      imageSrc = addWebpSuffixIfSupported(rawImageSrc);
      const rawLargeImageSrc = Image.createUrlImage({ image: images[0] });
      largeImageSrc = rawLargeImageSrc;
    }

    return (
      <div className="imageGallery">
        <div className="productDetail__gallery">

          <div className="hidden-md content d-flex align-items-center">
            <ProductTags
              language={language}
              variant={variant}
            />
            {images && images.length > 0 &&
              <Image 
                image={images[0]}
                className="hidden-md" 
                onClick={() => this.onClickImage(0)}
                alt={variant.product && variant.product.name[language]}
              />}
          </div>

          <div className="visible-md content">
            <ProductTags
              language={language}
              variant={variant}
            />
            {images && images.length > 0 &&
              <ReactImageMagnify
                {...{
                  smallImage: { isFluidWidth: true, src: imageSrc, alt: variant.product.name[language]},
                  largeImage: { src: largeImageSrc, width: 1200, height: 1200, alt: variant.product.name[language]},
                }}
                style={{ cursor: 'zoom-out' }}
                className="d-flex align-items-center"
                imageClassName="magnifier__defaultImg"
                // enlargedImageClassName="magnifier__enlargedImg"
                enlargedImageContainerClassName="magnifier__enlargedArea"
                enlargedImagePosition="over"
                // enlargedImagePortalId="zoomPortal"
                // isHintEnabled={true}
                // shouldHideHintAfterFirstActivation={false}
              />}
          </div>
        </div>

        {images && images.length > 0 &&
          <React.Fragment>
            <div className="imageGallery__nextImages" ref={(el) => {if (el) {if (el.scrollWidth > el.getBoundingClientRect().width) { el.classList.add('scrollable'); } }}}>
              {images
                .map((image: any, i: number) => {
                  return (
                    <div className="image d-flex align-items-center" key={image.id}>
                      <Image 
                        image={image} 
                        width={174} 
                        height={174} 
                        onClick={() => this.onClickImage(i)}
                        alt={`${variant.product && variant.product.name[language]} #${i + 1}`}
                        // something is needed to trigger re-render when image is loaded to determine new width
                        onLoad={() => this.setState(({imagesLoaded}) => ({imagesLoaded: (imagesLoaded || 0) + 1}))}
                      />
                    </div>
                  );
                })}
            </div>
            {openLightBox && (
              <Lightbox
                enableZoom={false}
                mainSrc={lighBoxImages[displayImage]}
                nextSrc={lighBoxImages[(displayImage + 1) % lighBoxImages.length]}
                prevSrc={lighBoxImages[(displayImage + images.length - 1) % images.length]}
                onCloseRequest={() => this.setState({ openLightBox: false })}
                onMovePrevRequest={() =>
                  this.setState({
                    displayImage: (displayImage + images.length - 1) % images.length,
                  })
                }
                onMoveNextRequest={() =>
                  this.setState({
                    displayImage: (displayImage + 1) % images.length,
                  })
                }
              />
            )}
          </React.Fragment>
        }

        {/* {!images && (
          <div
            style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}
            className="productDetail__slide"
          >
            <img style={{ width: 500 }} src={noImageUrl} />
          </div>
        )} */}
      </div>
    );
  }

  private onClickImage(index: number) {
    this.setState({
      displayImage: index,
      openLightBox: true,
    });
  }
}

export default ImageGallery;


// WEBPACK FOOTER //
// ./src/components/ProductDetail/components/ImageGallery/ImageGallery.tsx